import React, { useEffect, useState } from "react";
import { api } from "@/api/client.js";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

export function VehiclesPage() {
  const { ui } = useOrignalUi();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api("/api/vehicles").then((d) => setItems(d.items || [])).catch(() => {});
  }, []);

  return (
    <main className="og-page" data-testid="page-vehicles">
      <h1>{ui.vehicles.title}</h1>
      <p className="og-lead">{ui.vehicles.subtitle}</p>
      {items.map((v) => (
        <article key={v.id} className="og-card" data-testid={`vehicle-${v.id}`}>
          {v.photo_url ? <div className="og-meal-photo" style={{ backgroundImage: `url(${v.photo_url})` }} /> : null}
          <h2>{v.name}</h2>
          <p>{ui.vehicles.pending}</p>
          {v.notes ? <p className="og-hint">{v.notes}</p> : null}
        </article>
      ))}
    </main>
  );
}
